import render from './render'

export default {
  name: 'FooterActions',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  render
}
